/**
 * 本地占位规则 HTML（仅在接口无返回时作为 fallback 展示）。
 * ⚠️ 安全警告：此处内容会通过 {@html} 渲染，虽然调用方已使用 DOMPurify.sanitize()，
 * 但仍必须确保 rulesMap 中只包含可信的硬编码内容，禁止拼接任何用户输入或动态数据。
 */
const rulesMap = {
  "zh-cn": `
    <h2>IPO Win Phone 活动规则占位</h2>
    <p>本页为活动框架版本，当前用于承接后续运营、法务与设计确认后的正式规则文案。</p>
    <h3>1. 活动时间</h3>
    <p>可在这里补充活动开始、结束、奖励发放及失效时间等信息。</p>
    <h3>2. 参与条件</h3>
    <p>建议在此处明确开户、入金、申购、邀约或分享等任务门槛，并标注适用客户范围。</p>
    <h3>3. 奖励说明</h3>
    <p>奖励区可拆分为报名奖励、达标奖励、阶梯奖励及限量奖励，并补充发放形式与到账时效。</p>
    <h3>4. 风险提示</h3>
    <p>投资涉及风险。页面展示内容不构成任何投资建议，正式上线前请补充完整免责声明。</p>
  `,
  "zh-hk": `
    <h2>IPO Win Phone 活動規則佔位</h2>
    <p>本頁為活動框架版本，現階段用於承接後續營運、法務及設計確認後的正式條款內容。</p>
    <h3>1. 活動時間</h3>
    <p>可於此處補充活動開始、結束、獎勵發放及失效時間等資料。</p>
    <h3>2. 參與條件</h3>
    <p>建議於此處列明開戶、入金、申購、邀約或分享等任務門檻，並標註適用客戶範圍。</p>
    <h3>3. 獎勵說明</h3>
    <p>獎勵區可拆分為報名獎勵、達標獎勵、階梯獎勵及限量獎勵，並補充發放形式與到帳時效。</p>
    <h3>4. 風險提示</h3>
    <p>投資涉及風險。頁面展示內容不構成任何投資建議，正式上線前請補充完整免責聲明。</p>
  `,
  "en-us": `
    <h2>IPO Win Phone Rules Placeholder</h2>
    <p>This is a framework version of the campaign page and is reserved for the final approved rules copy.</p>
    <h3>1. Campaign Period</h3>
    <p>Use this section to define the campaign window, reward distribution timing, and expiry details.</p>
    <h3>2. Eligibility</h3>
    <p>You can later replace this with account opening, deposit, IPO subscription, referral, or sharing requirements.</p>
    <h3>3. Reward Details</h3>
    <p>Keep space here for sign-up rewards, milestone rewards, tier rewards, and any redemption notes.</p>
    <h3>4. Risk Disclosure</h3>
    <p>Investments involve risks. Please add the final compliance disclaimer before launch.</p>
  `,
  "ko-kr": `
    <h2>IPO Win Phone 이벤트 규정 자리</h2>
    <p>이 페이지는 추후 운영, 법무, 디자인 검수 후 최종 규정을 반영하기 위한 프레임워크 버전입니다.</p>
    <h3>1. 이벤트 기간</h3>
    <p>이곳에 이벤트 시작일, 종료일, 보상 지급 시점 및 만료 안내를 추가할 수 있습니다.</p>
    <h3>2. 참여 조건</h3>
    <p>계좌 개설, 입금, IPO 청약, 초대, 공유 등 실제 참여 조건을 이후에 교체하면 됩니다.</p>
    <h3>3. 보상 안내</h3>
    <p>신청 보상, 달성 보상, 단계형 보상, 한정 보상 등으로 나누어 정리할 수 있습니다.</p>
    <h3>4. 위험 고지</h3>
    <p>투자에는 위험이 따릅니다. 정식 배포 전 최종 면책 문구를 보완해 주세요.</p>
  `,
};

export function getRule(locale: string) {
  return rulesMap[locale as keyof typeof rulesMap] || rulesMap["zh-hk"];
}
